import { Button, Input } from "antd";
import { QurealViewer } from "qureal-editor";
import React, { useState } from "react";
import QurealSection from "../common/QurealSection";
import { useGenerateDocument, useGenerateDocumentOutline } from "../_actions/document";
import log, { bi } from "cslog"
import DocumentInput from "./DocumentInput";
import { useItemsFine, useSingleItem } from "../_actions/app/items";
import { MessageCodeView } from "../ai_home/ChatBox";
// import SinglePageView from "../show/showcase/views/singlepage/SinglePageView";

import QurealOneViewer from "../showwrapper/QurealOneViewer";
import QurealBasicEditor from "../qureal_editor/QurealBasicEditor";
import QurealBasicBubbleEditor from "../qureal_editor/QurealBasicBubbleEditor";
import AllUsers from "../all_users/AllUsers";


const { TextArea } = Input;

// const id = "80c40f3a-2937-41db-b5a1-305a722c09c0"
// const id = "5a7ea97b-a73a-48b4-9bfc-5e3954b4f6fc"
// const id = "09d1ef47-c78c-49eb-b87c-58c93ce4d38c"
// const id = "singlepage_Nr41Y"
// const id = "singlepage_8wx4D"
// const id = "payslip_demo_01"
// const id = "document_WIkM_"
const id = "document_Pr_ME"
const is_template = false
const is_document = true

function Sandbox() {
    const [temp, setTemp] = useState({})

    return (
        <QurealSection title="Sandbox" >
            <div style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
            }}>
                {/* <QurealBasicBubbleEditor
                    value="<h2>Hello</h2><h3>World</h3>"
                    wrapper_style={{
                        // height: "200px",
                        // height: "50px",
                        border: "1px solid black",
                    }}
                /> */}
                {/* <Button onClick={() => {
                    setTemp({
                        organization: "ultra_xpert_sX4Sn",
                        prefill: {
                            fact: {
                                fact: "Kanika",
                                source: "New source"
                            },
                            birthday_wish: {
                                person_name: "Anaya"
                            }
                        },
                        preview: true,
                        fit: true
                    })
                }}>Next</Button> */}
                <QurealOneViewer
                    slug={id}
                    type={is_template ? "template" : "creation"}
                    creation_type={is_document ? "document" : "singlepage"}
                    is_template={is_template}
                    is_document={is_document}
                    {...temp}
                    style={{
                        width: "100%",
                        height: "80vh",
                        backgroundColor: "black",
                    }}
                />
                {/* <MessageCodeView
                    data={{
                        language: "json",
                        code: one
                    }}
                /> */}
                {/* <Viewer data={one} /> */}
                {/* <QurealView id={id} is_template={is_template} /> */}
            </div>
        </QurealSection>

    );
}
export default Sandbox;



